import moment from 'moment';
import {
  getChannelList,
  getSaveOrUpdate,
  getNewsById,
  getNewsPreview,
  getLabelList,
  initiatorName,
  getCfg,
  batchSave,
} from '../../../services/articleSubmissions/edit';
import { labelWithGroup } from '../../../services/webSiteSetUp/contentRecommend';
import { getLeaveWordConf } from "../../../services/articlePublished/leaveWord";
import { getTemplateById } from '../../../services/moduleManage/create';
import { getAppCode } from '../../../utils/utils';

const initState = {
  formData: {
    id: '',
    appCode: getAppCode(),
    newstype: '1', // 0图文文章，1是外链
    needPush: '0',
    samePermissionsModuleId: '',
    publishUserNameType: 1,
    publishUserName: '',
    qrCode: '0',
    canLeaveWords: 0,
    needUp: '0',
    needDown: '0',
    selectIdType: 5, // 本组织
    fromApp: 17,
    isTiming: 0, // 是否定时发送
    timingPushTime: moment().add(2, 'hours'), // 定时发送时间
  },
  fileList: [],
  cfgData: {},
  defaultDataChannelId: [],
  initiatorNameData: {},
  publishModalVisible: false,

  articleList: [
    {
      newstype: '1', // 0图文文章，1是外链
      title: '',
      summary: '',
      url: '',
      coverPicFileId: '',
      content: '',
      fileId: '',
      labelList: [],
      status: '',
      statusDesc: '',
      channelId: undefined, // 栏目id
      fileList: [],
      filesLength: 0,
    }
  ],
  currentIndex: 0,
  pushIsAudit: 0, // 是否审批

};

export default {
  namespace: 'edit',
  state: initState,
  effects: {
    *fetchInitiatorName({ params }, { call, put, select }) {
      try {
        const response = yield call(initiatorName, params);
        const { formData } = yield select(state => state.edit);
        yield put({
          type: 'saveState',
          payload: {
            initiatorNameData: { ...response },
            formData: { ...formData, publishUserName: response.orgName },
          },
        });
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchChannelList({ params }, { call }) {
      try {
        const response = yield call(getChannelList, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchSaveOrUpdate({ params }, { call }) {
      try {
        const response = yield call(getSaveOrUpdate, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchBatchSave({ params }, { call }) {
      try {
        const response = yield call(batchSave, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchNewsById({ params }, { call, put }) {
      try {
        const response = yield call(getNewsById, params);
        yield put({
          type: 'fetchCfg',
          params: {
            orgid: response.orgid,
            appCode: getAppCode(),
          },
        });
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchTemplateById({ params }, { call }) {
      try {
        const response = yield call(getTemplateById, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchNewsPreview({ params }, { call }) {
      try {
        const response = yield call(getNewsPreview, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchLabelList({ params }, { call }) {
      try {
        const response = yield call(getLabelList, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchCfg({ params }, { call, put }) {
      try {
        const response = yield call(getCfg, params);
        yield put({
          type: 'saveState',
          payload: {
            cfgData: response,
          },
        });
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },

    *fetchLabelWithGroup({ params }, { call }) {
      try {
        const response = yield call(labelWithGroup, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchLeaveWordConf({ params }, { call, put }) {
      try {
        const { pushIsAudit } = yield call(getLeaveWordConf, params);
        yield put({
          type: 'saveState',
          payload: {
            pushIsAudit
          },
        });
        return Promise.resolve(pushIsAudit);
      } catch (error) {
        return Promise.reject(error.msg || "网络错误，请重试");
      }
    },
  },

  reducers: {
    saveState(state, { payload }) {

      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      const { articleList } = initState;
      return {
        ...initState,
        articleList: JSON.parse(JSON.stringify(articleList))
      };
    },
  },
};
